import { getAuthenticatedFetch } from "../../msal/authenticatedFetchService";

class ContactService {
    async sendContact(type: string, message: string, email: string) {
        const response = await getAuthenticatedFetch()(`${process.env.REACT_APP_SELF_SERVICE_SHARED_API_URL}/Contact`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                type, message, email
            })
        });
        
        const responseJson = await response.json();
        if (response.status != 200 || !responseJson.isSuccessStatusCode) {
            throw new Error();
        }
        
        return response;
    }
}

export default new ContactService();
